<template>
    <transition name="modal-fade" v-if="isVisible">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop >
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>
                <form class="row">

                    <div class="col-12 title">{{title}}</div>
                    <div class="box col-12 row">
                        <div class="col-12">
                            <label class="form-label">Business Name (If Any)</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.BusinessName" placeholder="Business Name">
                        </div>

                        <div class="col-6">
                            <label class="form-label">First Name<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.FirstName" placeholder="First Name">
                        </div>
                        <div class="col-6">
                            <label class="form-label">Last Name<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.LastName" placeholder="Last Name">
                        </div>

                        <div class="col-8">
                            <label class="form-label">Address<span class="mandatory">*</span></label>
                            
                                    <input type="text"
                                        v-model="PersonalInfo.Address"                                      
                                        placeholder="Address"
                                        class="form-control" />
                                    
                                
                        </div>
                        <div class="col-4">
                            <label class="form-label">Unit</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Unit" placeholder="Unit">
                        </div>

                        <div class="col-6 col-sm-4">
                            <label class="form-label">City<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.City" placeholder="City">
                        </div>
                        <div class="col-6 col-sm-4 ">
                            <label class="form-label">Province<span class="mandatory">*</span></label>
                            <select class="form-select" v-model="PersonalInfo.Province">
                                <option value="">Please Select</option>
                                <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                            </select>
                        </div>

                        <div class="col-6 col-sm-4">
                            <label class="form-label">Postal Code<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.PostalCode" placeholder="Postal Code" maxlength="7">
                        </div>

                         
                        <div class="col-6 col-sm-5">
                            <label class="form-label">Phone <span class="mandatory">*</span></label>
                            <input type="number" class="form-control" v-model="PersonalInfo.Phone" placeholder="Phone No." pattern="\d*" maxlength="10">
                        </div>
                        <div class="col-6 col-sm-5">
                            <label class="form-label">Fax</label>
                            <input type="number" class="form-control" v-model="PersonalInfo.Fax" placeholder="Fax" pattern="\d*" maxlength="10">
                        </div>

                        <div class="col-12 col-sm-9">
                            <label class="form-label">Email<span class="mandatory">*</span></label>
                            <input type="email" class="form-control" v-model="PersonalInfo.Email" placeholder="Email">
                        </div>


                    </div>
                     

                    <div class="col-12" style="text-align:right;">
                        <div class="btn btn-positive" @click="save">Save</div>
                    </div>


                </form>
                 
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {

        props: {
            visible: Boolean,
            data: Object
            
        },

        data() {
            return {
                PersonalInfo: this.data ? this.data : {},
                title: "Client/Home Owner Information",
                isVisible: this.visible, // Local visibility state

            }
        },
        mounted() {
             
        },
        watch: {
            visible(newVal) {
                this.isVisible = newVal; // Sync local state with prop changes
                 
                this.PersonalInfo = this.data ? this.data : {};
                 
            },
        },
        methods: {
            dataUpdate(obj) {

                console.log("dataUpdate", JSON.stringify(obj));
                this.PersonalInfo = obj;
            },
      
            save() {
                 
                if (!this.PersonalInfo.FirstName) {
                    this.$emit('alert', 'Please enter the first name');
                    return;
                }
                if (!this.PersonalInfo.LastName) {
                    this.$emit('alert', 'Please enter the last name');
                    return;
                }
                if (!this.PersonalInfo.Address) {
                    this.$emit('alert', 'Please enter the Address field');
                    return;
                }
                if (!this.PersonalInfo.City) {
                    this.$emit('alert', 'Please enter the City field');
                    return;
                }
                if (!this.PersonalInfo.Province) {
                    this.$emit('alert', 'Please choose the Province');
                    return;
                }
                if (!this.PersonalInfo.PostalCode) {
                    this.$emit('alert', 'Please enter the Postal Code field');
                    return;
                }
                if (!this.PersonalInfo.Phone) {
                    this.$emit('alert', 'Please enter the phone number');
                    return;
                }
                if (!this.PersonalInfo.Email) {
                    this.$emit('alert', 'Please enter the email address');
                    return;
                }

                this.$emit('saveProfile', this.PersonalInfo);
            }

        }
    }
</script>

<style scoped>
    .modal-overlay {
        z-index:999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        max-width:100%;
    }

    .modal-content {
        background-color: white;
        height: fit-content;
        width: 500px;
        max-width: 90vh;
        max-height: 90vh;
        margin:auto;
        padding: 0px 24px;
        border-radius: 20px;
       
    }


   

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .form-check-inline {
        margin: 4px 0px;
    }

    .form-check-label {
        vertical-align: middle;
    }

    .form-check-input {
        vertical-align: middle;
    }
</style>